export enum CalculationFactorKey {
  FUGITIVES = "fugitives",
  HEATING_AND_FUELS = "heating-and-fuels",
  HOTEL_STAYS = "hotel-stays",
  TRANSPORT = "transport",
  WASTE_CATEGORY = "waste-category",
  ELECTRICITY = "electricity",
  COOLING = "cooling",
  MEANS_OF_TRANSPORT = "means-of-transport",
  HOME_OFFICE = "home-office",
  REFRIGERANT = "refrigerant",
  FLIGHT_CLASS = "flight-class",
  CONTINENT_EMPLOYEE_COMMUTING = "continent-employee-commuting",
  RAIL_TRAVEL = "rail-travel",
  VEHICLE_FUEL_TYPE = "vehicle-fuel-type",
  PRIVATE_AND_RENTAL_VEHICLE = "private-and-rental-vehicle",
  WATER = "water",
  BEVERAGES = "beverages",
  FOOD = "food",
}

export enum HeatingType {
  DISTRICT_HEATING = "District Heating",
  STANDARD_HEATING = "Standard Heating",
}

export enum HeatingAcquisitionType {
  PURCHASED = "PURCHASED",
  SELF_GENERATED = "SELF_GENERATED",
}

export const GLOBAL_REGION = "Global";
